module.exports = __webpack_public_path__ + "static/media/08.cfc6e062.svg";